import StuartHeroSection from "./components/HeroSection";
import StuartStickyNav from "./components/StickyNav";
import StuartProcessingTimeSection from "./components/ProcessingTimeSection";
import StuartServicesSection from "./components/ServicesSection";
import StuartLocalAreaSection from "./components/LocalAreaSection";
import StuartTravelTimingSection from "./components/TravelTimingSection";
import StuartDestinationsSection from "./components/DestinationsSection";
import StuartTestimonialsSection from "./components/TestimonialsSection";
import StuartAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import StuartComparisonSection from "./components/ComparisonSection";
import StuartMistakesSection from "./components/MistakesSection";
import StuartHowItWorksSection from "./components/HowItWorksSection";
import StuartFAQSection, { faqs } from "./components/FAQSection";
import StuartHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import StuartFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function StuartPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Stuart"
        state="Florida"
        stateAbbr="FL"
        route="/cities/stuart"
        title="Emergency Passport Stuart, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Stuart, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Martin County, Treasure Coast anglers, snowbirds, and travelers."
        geoPlacename="Stuart, Florida"
        geoPosition="27.1975;-80.2530"
        faqs={faqs}
        servicesSchema={servicesList}
      />
      <StuartHeroSection />
      <StuartStickyNav />
      <StuartProcessingTimeSection />
      <StuartServicesSection />
      <StuartLocalAreaSection />
      <StuartTravelTimingSection />
      <StuartDestinationsSection />
      <StuartTestimonialsSection />
      <StuartAcceptanceFacilitiesSection />
      <StuartComparisonSection />
      <StuartMistakesSection />
      <StuartHowItWorksSection />
      <StuartFAQSection />
      <StuartHelpfulResourcesSection />
      <StuartFinalCTA />
    </div>
  );
}